// import React from 'react';

// export type VideoComponentProps = {
//   /**
//    * a text to be rendered in the component.
//    */
//   text: string
// };

// export function VideoComponent({ text }: VideoComponentProps) {
//   return (
//     <div>
//       {text}
//     </div>
//   );
// }

import * as React from "react";
// import { VideoComponentProps } from "./video-component-props";
import VideoComponentState from "./video-component-state";
//import "./video-component.css";
import { Caption } from "@att-bit/gvp.atoms.caption";
import { CTAView, CTAViewData } from "@att-bit/gvp.atoms.cta-view";
import { CaptionCMS } from "./cms-data";
import { ReportHelper } from './report-helper';
import { Utils } from "./utils";
import { IconSvg, IconSvgSizes } from "@att-bit/duc.components.icon-svg";
import { Spinner } from "@att-bit/duc.fragments.spinner";
import { playIcon, replayIcon } from "./constants";
import { Button } from "@att-bit/duc.components.button-base";
/* DUC Button cyclic Dependencies */
//import { Button, ButtonVariant } from "@att-bit/duc.components.button";

export type VideoComponentProps = {
  /**
   *  ref for the Video
   */
  ref?: any;
  /**
   *  Data to load video
   */
  data: VideoComponentData;
  /**
   *  Events for the Video
   */
  events?: VideoComponentEvents;
  /**
   *  Additional options for Video to enable different interfaces like Model etc.
   */
  options?: VideoComponentOptions;
  /**
   *  Additional id passed to Video
   */
  testId?: string;
};

export type VideoComponentData = {
  chapteredVideoData?: any;
  currentTime?: number;
  id?: string;
  controlsOpacity?: any;
  sources: string[];
  poster: string;
  recommendedVideosCTAViewData?: any;
  showCaption?: boolean;
  textTracks?: CaptionCMS[];
  title: string;
};

export type VideoComponentOptions = {
  loop?: boolean;
  muted?: boolean;
  autoPlay: boolean;
  width?: number;
  height?: number;
  playing?: boolean;
  volume?: number;
  className?: string;
  linkUrl?: string[];
  cinema?: boolean;
  safariAutoPlay?: boolean;
  containerWidth?: any;
  roundedCornersClassName: string;
};

export type VideoComponentEvents = {
  handleOnloadedmetadata(duration: number, playIndex: number): any;
  handleOnTimeUpdate(time: number, isAtEnd: boolean): any;
  handleOverlayReplay(playing: boolean): any;
  handleOverlayPlayPause(playing: boolean): any;
  handleOverlayRecommendedVideoItem(mediaId: string): any;
};
export class VideoComponent extends React.Component<VideoComponentProps, VideoComponentState> {
  state: VideoComponentState;
  private ref: any;
  private isTouchDevice = false;
  private player: any;
  private id!: string;
  private linkUrlData: any = [];
  private isChaptered: boolean = false;
  private chapteredVideosData: any = [];
  private playIndex = 0;
  private hls: any;
  private prevVideoLength: any = 0;
  private multipleVideoBp: any = [];

  constructor(props: VideoComponentProps) {
    super(props);
    this.state = new VideoComponentState();
    this.ref = React.createRef();
    this.isTouchDevice = !!('ontouchstart' in window) || !!(navigator.maxTouchPoints);
    this.hanldeOnloadedmetadata = this.hanldeOnloadedmetadata.bind(this);
    this.handleOnTimeUpdate = this.handleOnTimeUpdate.bind(this);
    this.handlePlayPause = this.handlePlayPause.bind(this);
    this.handleReplayClick = this.handleReplayClick.bind(this);
    this.handleRecommendedVideoItem = this.handleRecommendedVideoItem.bind(this);
    this.replay = this.replay.bind(this);
    this.onMediaLoadError = this.onMediaLoadError.bind(this);
    this.isChaptered = props.data.chapteredVideoData && props.data.chapteredVideoData.length > 0;
    this.chapteredVideosData = this.isChaptered ? props.data.chapteredVideoData : [];
    this.setId();
    this.linkUrlEvent(props?.options?.linkUrl);
  }

  hanldeOnloadedmetadata() {
    if (this.props.events && this.props.events.handleOnloadedmetadata) {
      this.props.events.handleOnloadedmetadata(this.ref.current.duration, this.playIndex);
    }
    this.setState({ loading: false });
  }

  handleOnTimeUpdate(e: any) {
    if (this.isChaptered) {
      this.handleNextChapteredVideo(e);
    } else {
      if (this.props.events && this.props.events.handleOnTimeUpdate) {
        this.props.events.handleOnTimeUpdate(e.currentTarget.currentTime, this.ref.current.ended);
      }
      if (this.ref.current.ended) {
        this.setState({ isAtEnd: this.ref.current.ended, ctrlCurrentTime: e.currentTarget.currentTime });
      } else if (this.state.isAtEnd) { // if user click to range after end of video
        this.setState({ isAtEnd: this.ref.current.ended, ctrlCurrentTime: e.currentTarget.currentTime });
      } else {
        this.setState({ ctrlCurrentTime: e.currentTarget.currentTime });
      }
    }
  }

  componentDidMount() {
    let videoContainerClassName = '';
    if(this.props.options.containerWidth  <= 250){
      videoContainerClassName = "VideoComponent__linkUrlContainer__LT250";
    } else if(this.props.options.containerWidth  > 250 && this.props.options.containerWidth  <= 500){
      videoContainerClassName = 'VideoComponent__linkUrlContainer__GT250__LT500';
    } else if(this.props.options.containerWidth  > 500 && this.props.options.containerWidth  <= 800){
      videoContainerClassName = 'VideoComponent__linkUrlContainer__GT500__LT800';
    }
    this.setState({videoContainerClassName: videoContainerClassName});
    this.handleHlsScriptLoad();
    if (this.ref?.current) {
      if (this.props?.options?.volume) {
        const vol = this.props.options.volume / 100;
        if (vol > 0 && vol < 1) {
          this.ref.current.volume = vol;
        }
        this.ref.current.muted = vol <= 0 ? true : false;
      }
      if (this.props.data.currentTime) {
        this.ref.current.currentTime = this.props.data?.currentTime;
      }
      this.props?.options?.playing ? this.ref.current.play() : this.ref.current.pause();
    }
    if (this.isChaptered) {
      let prevVideoLength = 0;
      for (let i = 0; i <= this.chapteredVideosData.length; i++) {
        if (this.chapteredVideosData[i]) {
          prevVideoLength = prevVideoLength + this.chapteredVideosData[i].seconds;
          const videoDetailsObj = {
            playIndex: i,
            videoLength: prevVideoLength,
          };
          this.multipleVideoBp.push(videoDetailsObj);
        }
      }
    }
  }

  componentDidUpdate(prevProps: Readonly<VideoComponentProps>, prevState: Readonly<VideoComponentState>, snapshot?: any): void {
    /* mute Accessibility fix */
      if (prevProps.options.muted !== this.props.options.muted && this.ref?.current) {
        if (this.props?.options?.muted) {
          this.ref.current.muted = true;
          this.ref.current.defaultMuted = true;
        } else {
          this.ref.current.muted = false;
          this.ref.current.defaultMuted = false;
        }
      }
  }
  handleNextChapteredVideo(e: any) {
    this.player = document.querySelector('#' + this.id);
    if (this.ref.current.ended) {
      this.playIndex++;
      if (this.state.useHls) {
        this.hls.destroy();
      }
      if (this.chapteredVideosData[this.playIndex]) {
        let prevVideoLength = 0;
        for (let i = 0; i <= this.playIndex - 1; i++) {
          prevVideoLength = prevVideoLength + this.chapteredVideosData[i].seconds;
        }
        this.prevVideoLength = prevVideoLength;
        if (this.props.events && this.props.events.handleOnTimeUpdate) {
          this.props.events.handleOnTimeUpdate(this.prevVideoLength, false);
        }
        this.linkUrlData = [];
        this.linkUrlEvent(this.chapteredVideosData[this.playIndex].linkUrl);
        this.setState({ chapteredVideoSource: this.chapteredVideosData[this.playIndex].sources }, () => {
          this.setState({ useHls: false });
          this.player.load();
          this.player.play();
          // @ts-ignore: TODO
          window.chapteredVideoData = this.chapteredVideosData[this.playIndex];
          const reportHelper = new ReportHelper(this.ref.current, this.chapteredVideosData[this.playIndex]);
        });
        this.setState({ ctrlCurrentTime: this.prevVideoLength });
      } else {
        if (this.props.events && this.props.events.handleOnTimeUpdate) {
          this.props.events.handleOnTimeUpdate(this.prevVideoLength + e.currentTarget.currentTime, true);
        }
        this.setState({ isAtEnd: true, ctrlCurrentTime: this.prevVideoLength + e.currentTarget.currentTime });
      }
    } else {
      this.setState({ isAtEnd: this.ref.current.ended });
      if (this.props.events && this.props.events.handleOnTimeUpdate) {
        this.props.events.handleOnTimeUpdate(
          e.currentTarget.currentTime + this.prevVideoLength,
          this.ref.current.ended);
      }
    }
  }

  handleMultiChapteredSeek(timeToSeek: number, seekIndex: number) {
    if (this.chapteredVideosData[seekIndex]) {
      if (seekIndex !== this.playIndex) {
        this.playIndex = seekIndex;
        if (this.state.useHls) {
          this.hls.destroy();
          this.setState({ useHls: false });
        }
        this.linkUrlData = [];
        this.linkUrlEvent(this.chapteredVideosData[this.playIndex].linkUrl);
        // @ts-ignore: TODO
        window.chapteredVideoData = this.chapteredVideosData[this.playIndex];
        const reportHelper = new ReportHelper(this.ref.current, this.chapteredVideosData[this.playIndex]);
        this.setState({ chapteredVideoSource: this.chapteredVideosData[this.playIndex].sources }, () => {
          this.player.load();
          this.player.play();
          this.setCurrentTimeAndState(timeToSeek);
        });
      } else {
        this.setCurrentTimeAndState(timeToSeek);
      }
    }
  }

  setCurrentTimeAndState(timeToSeek: number) {
    if (this.props.events && this.props.events.handleOnTimeUpdate) {
      this.props.events.handleOnTimeUpdate(timeToSeek, false);
    }
    this.setState({ ctrlCurrentTime: timeToSeek });
    if (this.playIndex === 0) {
      this.ref.current.currentTime = timeToSeek;
    } else {
      this.ref.current.currentTime = timeToSeek - this.prevVideoLength;
    }
  }

  shouldComponentUpdate(nextProps: VideoComponentProps, nextState: VideoComponentState) {
    if (nextProps.options && this.ref && this.ref.current) {
      if (nextProps.options.volume !== this.props?.options?.volume) {
        const vol = (nextProps.options.volume)! / 100;
        if (vol > 0 && vol < 1) {
          this.ref.current.volume = vol;
        }
        this.ref.current.muted = vol <= 0 ? true : false;
      }
      if (nextProps.data.currentTime !== this.props.data.currentTime) {
        this.checkSourceTobePlayed(nextProps.data.currentTime);
      }
      if (nextProps.options.playing !== this.props?.options?.playing && !nextState.isAtEnd) {
        nextProps.options.playing ? this.ref.current.play() : this.ref.current.pause();
      } else if (nextProps.options.playing && nextState.isAtEnd) {
        this.replay();
      }
    }
    return true;
  }

  checkSourceTobePlayed(timeToSeek: any) {
    let seekIndex = 0;
    if (this.multipleVideoBp.length > 0) {
      let chapteredVideoFound: boolean = false;
      this.multipleVideoBp.forEach((element: { videoLength: number; playIndex: number; }) => {
        if (timeToSeek > element.videoLength) {
          seekIndex = element.playIndex + 1;
          this.prevVideoLength = element.videoLength;
          this.handleMultiChapteredSeek(timeToSeek, seekIndex);
          chapteredVideoFound = true;
          return;
        }
      });
      if (!chapteredVideoFound) {
        seekIndex = 0;
        this.prevVideoLength = 0;
        this.handleMultiChapteredSeek(timeToSeek, seekIndex);
      }
    } else {
      this.ref.current.currentTime = timeToSeek;
    }
  }

  setId() {
    const videoTag = document.querySelectorAll('.' + "VideoComponent__videoElement");
    if (videoTag.length > 0) {
      this.id = 'videoPlayer_playerView' + this.props.data.id + '_' + videoTag.length;
    } else {
      this.id = 'videoPlayer_playerView' + this.props.data.id;
    }
  }

  handleHlsScriptLoad() {
    // @ts-ignore
    if (window.Hls && this.state.useHls) {
      this.buildHlsSource();
    }
  }

  onMediaLoadError() {
    this.setState({ useHls: true });
    this.buildHlsSource();
  }

  linkUrlEvent(linkUrl: any) {
    if (!this.linkUrlData.length && linkUrl) {
      const urlString = this.props?.options?.linkUrl;
      if (urlString) {
        try {
          if (urlString) {
            urlString.forEach((url) => {
              const e = JSON.parse(url);
              const urlText = e.u;
              const obj = {
                begin: Math.floor(Utils.timecodeToSeconds(e.b)),
                bgColor: e.bc || undefined,
                end: Math.floor(Utils.timecodeToSeconds(e.e)),
                link: urlText,
                position: e.p || undefined,
                title: e.n || undefined,
              };
              this.linkUrlData.push(obj);
            });
          }
        } catch (e) {
          console.error('JSON.parse exception occrrerd for caption in asset', e);
        }
      }
    }
    return this.linkUrlData;
  }
  
  getPlayButton(val=IconSvgSizes.XXL) {
    return <IconSvg size={val} svgNodeStr={playIcon} pictogram={true} altText={'Video play Icon - player view'} />;
  }
  
  render() {
    const isAtEnd = this.state.isAtEnd;
    const isLoading = this.state.loading;
    const isCinema = this.props.options && this.props.options.cinema;
    const modalClass = !isCinema ? "VideoComponent__modal" : '';
    const linkUrlContainer = ["VideoComponent__linkUrlContainer", modalClass];
    const linkUrlContainerClass = linkUrlContainer.join(' ');
    let gvpSize = IconSvgSizes.XXL;;  
    if(this.props.options.containerWidth <= 500) {
      gvpSize = IconSvgSizes.LG;
    } else if((this.props.options.containerWidth > 500) && (this.props.options.containerWidth <= 800)){
      gvpSize = IconSvgSizes.XL;
    }

    return (
      <>
      {/*
              // @ts-ignore */}
              <style jsx global>{`
              /* core elements */
              .VideoComponent__fillElement {
                padding-bottom: 56.207%;
                pointer-events: none;
              }
              
              .VideoComponent__videoElement {
                position: absolute;
                min-width: 100%;
                height: 100%;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
              }
              
              @-webkit-keyframes VideoComponent__fadein {
                0% {
                  opacity: 0;
                }
                100% {
                  opacity: 1;
                }
              }
              
              @keyframes VideoComponent__fadein {
                0% {
                  opacity: 0;
                }
                100% {
                  opacity: 1;
                }
              }
              
              /* hiding iOS default play button */
              .VideoComponent__videoElement::-webkit-media-controls-panel {
                display: none !important;
                -webkit-appearance: none;
              }
              
              .VideoComponent__videoElement::\--webkit-media-controls-play-button {
                display: none !important;
                -webkit-appearance: none;
              }
              
              .VideoComponent__videoElement::-webkit-media-controls-start-playback-button {
                display: none !important;
                -webkit-appearance: none;
              }
              
              .VideoComponent__videoPlayButton {
                display: flex;
                width: 100%;
                height: 100%;
                align-items: center;
                justify-content: center;
              }

              .VideoComponent__videoPlayButton > button {
                background: transparent;
                border: 0;
              }
              
              .VideoComponent__videoOverlay {
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
              }
              
              .VideoComponent__videoLoaderButton {
                width: 100px;
                height: 100px;
                fill: #fff;
                -webkit-animation: VideoComponent__fadeinout 1s linear 1 forwards;
                animation: VideoComponent__fadein 1s linear 1 forwards;
                position: relative;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
              
              /* end screen */
              .VideoComponent__endScreen {
                /*position: absolute;
                width: 100%;
                height: 100%;*/
                position: relative;
                top: 50%;
                transform: translate(0, -50%);
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                opacity: 0.8;
                font-size: 1.2em;
              }
              
              .VideoComponent__endScreenSection {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 5px;
                margin-right: 5px;
                padding: 7px;
                padding-left: 14px;
                padding-right: 14px;
                margin: 7px;
                border-radius: 5px;
                border-style: none;
                white-space: nowrap;
                min-height: 50px;
                cursor: pointer;
              }
              
              .VideoComponent__endScreenIcon {
                width: 50px;
                height: 50px;
                background-color: transparent;
                fill: #f1f1f1;
                font-size: 35px;
                border: 0;
                cursor: pointer;
              }
              
              .VideoComponent__endScreenRecommendationVideoContainer {
                height: 80%;
                width: 100%;
              }
              
              .VideoComponent__recommendedVideoSection {
                display: flex;
                flex-direction: row;
                width: 100%;
                max-height: 80%;
                justify-content: space-evenly;
              }
              
              .VideoComponent__recommendedVideoItem {
                display: flex;
                flex: 1 1 100%;
                flex-direction: column;
                margin: 15px;
              }
              
              .VideoComponent__endScreenRecommendationTitle {
                display: block;
                margin: 15px;
              }
              
              @media screen and (max-width: 800px) {
                .VideoComponent__endScreenRecommendationVideoContainer {
                  height: 70%;
                }
                .VideoComponent__endScreenRecommendationTitle {
                  margin: 5px;
                }
                .VideoComponent__recommendedVideoSection {
                  max-height: 70%;
                }
                .VideoComponent__recommendedVideoItem {
                  margin: 5px 15px;
                }
                .VideoComponent__endScreenSection {
                  margin: 0px;
                }
              }
              
              .VideoComponent__topleft,
              .VideoComponent__lefttop {
                left: 5%;
                top: 10%;
              }
              
              .VideoComponent__topright,
              .VideoComponent__righttop {
                right: 5%;
                top: 10%;
              }
              
              .VideoComponent__topcenter,
              .VideoComponent__centertop {
                left: 40%;
                top: 10%;
              }
              
              .VideoComponent__bottomleft,
              .VideoComponent__leftbottom {
                bottom: 15%;
                left: 5%;
              }
              
              .VideoComponent__bottomright,
              .VideoComponent__rightbottom {
                bottom: 15%;
                right: 5%;
              }
              
              .VideoComponent__bottomcenter,
              .VideoComponent__centerbottom {
                bottom: 15%;
                left: 40%;
              }
              
              .VideoComponent__centerleft,
              .VideoComponent__leftcenter {
                left: 5%;
                bottom: 45%;
              }
              
              .VideoComponent__centerright,
              .VideoComponent__rightcenter {
                right: 5%;
                bottom: 45%;
              }
              
              .VideoComponent__center {
                left: 40%;
                bottom: 45%;
              }
              
              .VideoComponent__bgColor_black {
                background-color: #000;
              }
              
              .VideoComponent__bgColor_blue {
                background-color: #0057b8;
              }
              
              .VideoComponent__bgColor_white {
                background-color: #ffff;
              }
              
              .VideoComponent__text_transparent {
                width: 100%;
                height: 100%;
                display: block;
              }
              
              .VideoComponent__link_transparent {
                background-color: transparent;
                top: 55px;
                -ms-flex-direction: column;
                flex-direction: column;
                justify-content: center;
                min-height: 0;
                max-height: 100%;
                min-width: 0;
                max-width: 854px;
                position: absolute;
                width: 854px;
                height: 76%;
                align-items: stretch;
              }
              
              .VideoComponent__linkUrlContainer {
                position: absolute;
                width: 100%;
                height: 100%;
              }            
              `}</style>
      <div
        data-test-id={this.props.testId}
        className={this.props.options && this.props.options.className}
        onClick={this.handlePlayPause}
      >
        <video
          id={this.id}
          aria-label={`${this.props?.data?.title} video`}
          className={"VideoComponent__videoElement" + this.props?.options?.roundedCornersClassName}
          style={{ opacity: this.props?.options?.playing ? 1 : 0.75 }}
          tabIndex={-1}
          playsInline={true}
          loop={this.props.options && this.props.options.loop}
//          muted={this.props.options && this.props.options.muted}
          autoPlay={this.props?.options?.autoPlay ? this.props?.options?.autoPlay : this.props?.options?.safariAutoPlay }
          controls={false}
          width={this.props?.options?.width}
          height={this.props?.options?.height}
          onLoadedMetadata={this.hanldeOnloadedmetadata}
          onTimeUpdate={this.handleOnTimeUpdate}
          onError={this.onMediaLoadError}
          ref={this.ref}
          preload="none"
        >
          {(() => {
            if (this.state.chapteredVideoSource) {
              return (<source type="video/mp4" src={this.state.chapteredVideoSource} />);
            } else if (!this.state.useHls) {
              return (<source type="video/mp4" src={this.props.data.sources[1]} />);
            }
          })()}
        </video>
        <div className={linkUrlContainerClass + ' ' +  this.state.videoContainerClassName}>
          {this.getUrl()}
        </div>
        {this.getCaption()}

        <div className={"VideoComponent__videoOverlay"} style={{ display: this.props?.options?.playing ? 'none' : 'inline' }} >
          {(() => {
            if (!isAtEnd) {
              if (isLoading) {
                return (
                  <div className={"VideoComponent__videoLoaderButton"}>
                    <Spinner style={{ margin: 48 }} />
                  </div>
                );
              } else {
                if (!isCinema || (isCinema && !this.isTouchDevice)) {
                  return (
                    <div className={"VideoComponent__videoPlayButton"}>
                      <button
                        aria-label={'Play Video'}
                        title={'Play Video'}
                        className={'VideoComponent__CTAbutton color-gray-200'}
                      >
                        {this.getPlayButton(gvpSize)}
                      </button>
                    </div>
                  );
                }
              }
            }
          })()}
          {isAtEnd ?
            <div
              className={"VideoComponent__endScreen color-white"}
              style={{
                height: this.props.data.recommendedVideosCTAViewData
                  && this.props.data.recommendedVideosCTAViewData.length > 0 ? '100%' : 'auto',
              }}
            >
              {this.props.data.recommendedVideosCTAViewData && this.props.data.recommendedVideosCTAViewData.length > 0
                ?
                <div className={"VideoComponent__endScreenRecommendationVideoContainer"}>
                  <span className={"VideoComponent__endScreenRecommendationTitle"}>Related Videos:</span>
                  <div className={"VideoComponent__recommendedVideoSection"}>
                    {this.props.data.recommendedVideosCTAViewData.map((value: CTAViewData, index: any) => {
                      return (
                        // tslint:disable-next-line:jsx-key
                        <div
                          className={"VideoComponent__recommendedVideoItem"}
                          // tslint:disable-next-line:jsx-no-lambda
                          onClick={() => this.handleRecommendedVideoItem(value.id)}
                        >
                          <CTAView
                            data={value}
                            options={{ autoPlay: false }}
                          />
                        </div>);
                    })}
                  </div>
                </div>
                : null}
              <div className={"VideoComponent__endScreenSection font-regular bg-gray-800"} onClick={this.handleReplayClick}>
                Replay &nbsp;
                <IconSvg size={IconSvgSizes.MD} svgNodeStr={replayIcon} altText={'Video replay Icon'}/>
              </div>
              {/* {this.ratings && !this.ratings.submitted ?
                                <div
                                  className={"VideoComponent__endScreenSection color-gray-200"}
                                  event-click={(event: Event) => { event.stopImmediatePropagation() }}>
                                    Rate Video
                                {this.ratings ? this.ratings.genRatings("VideoComponent__endScreenIcon) : null}
                                </div> : null
                            } */}
            </div> : null}
        </div>
        <div className={"VideoComponent__fillElement"} />
      </div>
      </>
    );
  }

  private buildHlsSource() {
    // @ts-ignore
    if (window.MediaSource && window.location.protocol.match('http')) {
      const url = this.props.data.sources[0];
      this.player = document.querySelector('#' + this.id);
      if (this.player.canPlayType(url)) {
        this.player.src = url;
        this.player.addEventListener('loadedmetadata', () => {
          this.player.play();
        });
      }
      // @ts-ignore 
      else if (window.Hls.isSupported()) {
      // @ts-ignore
        this.hls = new window.Hls();
        this.hls.loadSource(url);
        this.hls.attachMedia(this.player);
        this.player.play();
       // @ts-ignore
        this.hls.on(window.Hls.Events.ERROR, () => {
          this.hls.detachMedia();
          this.setState({ useHls: false });
          this.player.play();
        });
      } else {
        this.setState({ useHls: false });
      }
    } else {
      this.setState({ useHls: false });
    }
  }

  private handlePlayPause(event: any) {
    event.stopPropagation();
    if (this.props.events && this.props.events.handleOverlayPlayPause) {
      this.props.events.handleOverlayPlayPause(!this.props?.options?.playing);
    }
  }

  private getCaption() {
    let ctrlCurrentTime = this.state.ctrlCurrentTime;
    let textTrack = this.props.data.textTracks;
    if (this.isChaptered && this.ref.current) {
      ctrlCurrentTime = this.ref.current.currentTime;
      textTrack = this.chapteredVideosData[this.playIndex] &&
        this.chapteredVideosData[this.playIndex].captions &&
        this.chapteredVideosData[this.playIndex].captions.captions ?
        this.chapteredVideosData[this.playIndex].captions.captions
        : textTrack;
    }

    if (!(this.props.data && this.props.data.showCaption)
      || (ctrlCurrentTime >= this.ref.current.duration)) {
      return null;
    }
    return (
      <Caption
        data={{
          controlsOpacity: this.props.options && this.props.options.cinema ? this.props.data.controlsOpacity : 0,
          currentTime: ctrlCurrentTime,
          textTracks: textTrack!,
        }}
      />
    );
  }

  private handleRecommendedVideoItem(mediaId: string) {
    this.props?.events?.handleOverlayRecommendedVideoItem(mediaId);
  }

  private handleReplayClick(event: any) {
    event.stopPropagation();
    if (this.props.events && this.props.events.handleOverlayReplay) {
      if (this.isChaptered) {
        this.prevVideoLength = 0;
        this.playIndex = 0;
        this.setState({ chapteredVideoSource: this.props.data.chapteredVideoData[this.playIndex].sources }, () => {
          this.player.load();
          this.replay();
        });
      } else {
        this.replay();
      }
      this.props.events.handleOverlayReplay(!this.props?.options?.playing);
    }
  }

  private replay() {
    this.ref.current.currentTime = 0;
    this.ref.current?.play();
  }

  private getUrl() {
    let linkObj;
    let linkPos;
    let bgColor;
    const data = this.linkUrlData;
    let ctrlCurrentTime = this.state.ctrlCurrentTime;
    if (this.isChaptered && this.ref && this.ref.current) {
      ctrlCurrentTime = this.ref.current.currentTime;
    }
    for (const linkValue of data) {
      if (ctrlCurrentTime >= linkValue.begin && ctrlCurrentTime <= linkValue.end) {
        linkObj = linkValue;
        // @ts-ignore: TODO
        linkPos = linkObj.position ? `VideoComponent__${linkObj.position} ` : "VideoComponent__centerleft";
        const bColor = linkObj.bgColor.toLowerCase();
        return (
          /*<a
            report-title="linkUrl"
            link-title={linkObj.title + ' Link'}
            link-url={linkObj.link}
            className={bColor === 'blue' && linkObj.title ? blueButtonStyle :
              linkObj.title ? blackButtonStyle : `${"VideoComponent__linkTransparent"}  ${"VideoComponent__textTransparent"}`}
            target="_blank"
            href={linkObj.link}
          >
            {"Test"}
          </a>*/
          <div
            className={ linkObj.title ? linkPos : `${"VideoComponent__linkTransparent"}  ${"VideoComponent__textTransparent"}`}
            style={{ position: 'absolute' }}
          >
            <Button
              // className={
              //     "CTAView__link" +
              //     ' btn btn-primary btn-arrow ' +
              //     (overlayTextData.theme &&
              //     overlayTextData.theme.toLowerCase() === 'dark' &&
              //     !isMobile
              //         ? "CTAView__linkWhite" + ' on-dark'
              //         : "CTAView__linkBlack")
              // }
              variant={ bColor === 'blue' ? 'primary' : 'secondary' }
              target="_blank"
              report-title="linkUrl"
              link-title={linkObj.title + ' Link'}
              link-url={linkObj.link}
              href={linkObj.link}
              /*onClick={this.overlayTextLinkClick}*/
            >
              {linkObj.title}
            </Button>
          </div>
        );
      }
    }
  }

}

export default VideoComponent;
